<script>
import {
  modalMethods,
  clientProgramMethods,
  clientProgramComputed,
} from '@state/helpers';

export default {
  components: {},
  props: {
    color: {
      type: String,
      required: false,
      default: null,
    },
    noPad: {
      type: Boolean,
      required: false,
    },
    selectedItem: {
      type: Object,
      required: false,
      default: null,
    },
    itemType: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...clientProgramComputed,
    hasActionBtns() {
      return this.$slots.default;
    },
  },
  mounted() {},
  methods: {
    ...clientProgramMethods,
    ...modalMethods,
    confirmDelete() {
      this.setSelectedItem({
        ...this.selectedItem,
        context: this.itemType ? this.itemType : null,
      });
      this.$bvModal.show('confirmation-modal');
    },
    handleSave() {
      this.$emit('action-footer-save');
    },
    deselectWeek() {
      this.setSelectedWeek(null);
    },
  },
};
</script>

<template>
  <div :class="['action-footer-wrapper', { 'no-pad': noPad }]">
    <div :class="['action-footer', color]">
      <span class="action-title">
        <slot name="actionState"></slot>
        <slot name="secondaryAction"></slot>
      </span>
      <div class="btn-group">
        <BaseButton
          v-if="!hasActionBtns"
          type="button"
          class="btn-primary btn-clear"
          @click="confirmDelete"
        >
          <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon-trash'" v-bind:svg-inline="''" v-if="!hasActionBtns" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.5 1H14v2H0V1h3.5l1-1h5l1 1zM3 18c-1.1 0-2-.9-2-2V4h12v12c0 1.1-.9 2-2 2H3z" fill="#000"/></svg>
          Delete <span v-if="itemType">{{ itemType }}</span>
        </BaseButton>

        <slot></slot>

        <span class="divider-vertical" v-if="!hasActionBtns">&nbsp;</span>
        <BaseButton
          v-if="!hasActionBtns"
          type="button"
          class="btn-primary btn-clear"
          @click="handleSave"
        >
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon-save'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.222 0H1.89C.84 0 0 .85 0 1.889V15.11C0 16.15.84 17 1.889 17H15.11c1.04 0 1.89-.85 1.89-1.889V3.778L13.222 0zM8.5 15.111a2.83 2.83 0 01-2.833-2.833A2.83 2.83 0 018.5 9.444a2.83 2.83 0 012.833 2.834A2.83 2.83 0 018.5 15.11zM1.889 5.667h9.444V1.889H1.89v3.778z" fill="#fff"/></svg>
          Save <span v-if="itemType">{{ itemType }}</span>
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

.action-footer-wrapper {
  background-color: transparent;
  bottom: 1rem;
  padding: 0 6rem 0 0;
  position: fixed;
  width: 100%;
  z-index: 1;
  @media screen and (max-width: 1024px) {
    padding-right: 19.5rem;
  }

  .action-footer {
    align-items: center;
    background-color: $color-header-bg;
    border-radius: $size-input-border-radius;
    box-shadow: 0 0 0.8rem rgba($color-black-wo-rgb, 0.25);
    color: white;
    display: flex;
    font-size: 1.4rem;
    font-weight: 600;
    justify-content: space-between;
    letter-spacing: 0.116667px;
    line-height: 1.9rem;
    padding: 1rem 2.2rem;
    width: 100%;

    &.black {
      background-color: black;
    }

    .action-title {
      &.link-deselect,
      .link-deselect {
        margin-left: 1rem;
        opacity: 0.5;
        text-decoration: underline;
        transition: opacity $duration-animation-base;

        &:hover {
          cursor: pointer;
          opacity: 1;
        }
      }
      .saved-status {
        opacity: 0.6;
      }
    }

    .divider-vertical {
      align-self: center;
      border-left: 1px solid white;
      height: 3rem;
      opacity: 0.5;
    }

    .button {
      ::v-deep .icon-trash,
      ::v-deep .icon-calendar,
      ::v-deep .icon-save {
        margin-right: 1rem;

        path {
          fill: white;
        }
      }

      ::v-deep .icon-calendar {
        height: 1.8rem;
        width: 1.8rem;
      }

      &.btn-clear {
        &:active {
          background: rgba($color-white-wo-rgb, 0.1);
          color: white;
        }

        &:focus {
          background: transparent;
          color: white;
        }
      }
    }

    .btn-clear {
      color: white;
    }
  }
}
</style>
